export * from './home-slider.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/index.ts